import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Typography } from '@mui/material';
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO';
import { formatDateWithoutDay } from '@src/services/Formatter';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  selectedPayment?: GetPaymentResultDTO | null;
};

const LastPaymentCard: FC<Props> = ({ selectedPayment }) => {
  const { t } = useTranslation();
  // theme available for future styling;

  if (!selectedPayment) return null;

  const { plannedOnDateUTC, amount } = selectedPayment;
  const formattedDate = formatDateWithoutDay(plannedOnDateUTC);
  const formattedAmount = `${(amount % 1).toFixed(2).split('.')[1]}$`;

  const styles = {
    card: {
      padding: '2rem',
      borderRadius: '25px',
      border: '2px solid #333',
      width: { xs: '100%', sm: '62%',lg:'55%' },
      margin: '2rem 0.3rem',
    },
    details: {
      display: 'flex',
      justifyContent: 'space-between',
      mt: '1rem',
    },
    dateAndAmount: {
      fontSize: '0.8rem',
    },
    icon: {
      transform: 'scaleX(-1)',
    },
    amount: {
      fontSize: '0.8rem',
    },
    cents: {
      fontSize: '0.8rem',
    },
  };

  return (
    <Box sx={styles.card}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <RefreshIcon sx={styles.icon} />
        <Typography>{t('payment.futureDate')}</Typography>
      </Box>
      <Box sx={styles.details}>
        <Typography sx={styles.dateAndAmount}>{formattedDate}</Typography>
        <Typography sx={{ display: 'flex', alignItems: 'center' }}>
          <span style={styles.amount}>{Math.floor(amount)}</span>
          <span style={styles.cents}>.{formattedAmount}</span>
        </Typography>
      </Box>
    </Box>
  );
};

export default LastPaymentCard;
